module.exports = __webpack_public_path__ + "static/media/aws5.c21aa21e.png";